import * as Types from '../types/BeslenmeCategory'
import Initials from '../initials/BeslenmeCategory'

export default function Reducers (state = Initials, action) {
  switch (action.type) {

    case Types.GETALL_SUCCESS:
      return {
        ...state,
        All: action.payload,
        messages: [],
        CustomID: Math.random()
      }

    case Types.GETONE_SUCCESS:
      return {
        ...state,
        One: action.payload,
        messages: [],
        CustomID: Math.random()
      }

    case Types.CREATE_SUCCESS:
      return {
        ...state,
        All: state.All.concat(action.payload),
        messages: [],
        CustomID: Math.random()
      }

    case Types.UPDATE_SUCCESS:
      var foundedObj = state.All.find(aa=> aa.beslenmeCategory_id == action.payload?.beslenmeCategory_id)
      foundedObj = action.payload
      return {
        ...state,
        All: state.All,
        messages: [],
        CustomID: Math.random()
      }

    default:
      return state
  }
}
